import { Component, inject, Injector, ViewChild } from '@angular/core';
import { ChangeVendorModalComponent } from './shared/components/change-vendor-modal/change-vendor-modal.component';
import { AppBaseComponent } from './shared/app-base.component';
import { AuthService, ReplaceableComponentsService } from '@abp/ng.core';
import { UserMenuService } from '@abp/ng.theme.shared';
import { eThemeLeptonXComponents, eUserMenuItems } from '@volosoft/abp.ng.theme.lepton-x';
import { SmartInvoicingBreadcrumbComponent } from './shared/components/smart-invoicing-breadcrumb/smart-invoicing-breadcrumb.component';
import { AppConsts } from './shared/AppConsts';
import { PrimeNG } from 'primeng/config';
import { PRIMENG_ES } from './i18n/primeng-es';

@Component({
  standalone: false,
  selector: 'app-root',
  template: `
    <abp-loader-bar></abp-loader-bar>
    <abp-dynamic-layout></abp-dynamic-layout>
    <app-change-vendor-modal></app-change-vendor-modal>
    <ngx-spinner type="ball-clip-rotate" color="#F8F7EE" size="default"></ngx-spinner>
  `,
})
export class AppComponent extends AppBaseComponent {
  @ViewChild(ChangeVendorModalComponent) changeVendorModal: ChangeVendorModalComponent;
  private readonly primengConfig = inject(PrimeNG);

  constructor(
    injector: Injector,
    private readonly replaceableComponents: ReplaceableComponentsService,
    private readonly _userMenu: UserMenuService,
    readonly _authService: AuthService) {
      super(injector);
      if (!_authService.isAuthenticated) {
        _authService.navigateToLogin();
      }

      this.primengConfig.setTranslation(PRIMENG_ES)
      this.removeComponents();
      this.removeUserMenuItems();
  }

  private removeUserMenuItems(): void {
    this._userMenu.removeItem(eUserMenuItems.MyAccount);
    this._userMenu.removeItem(eUserMenuItems.LinkedAccounts);
    this._userMenu.removeItem(eUserMenuItems.SecurityLogs);
    this._userMenu.removeItem(eUserMenuItems.AuthorityDelegation);
    this._userMenu.removeItem(eUserMenuItems.Sessions);
    this._userMenu.removeItem(eUserMenuItems.ExternalLogins);
    this._userMenu.removeItem(eUserMenuItems.BackToImpersonator);
    this._userMenu.removeItem(AppConsts.GdprNavigationMenuItemName);

    this._userMenu.addItems([
      {
        order: 0,
        name: AppConsts.ChangeCurrentVendorMenuItemName,
        textTemplate: {
          text: this.l('::ChangeCurrentVendor'),
          icon: 'pi pi-map-marker',
        },
        id: AppConsts.ChangeCurrentVendorMenuItemName,
        action: () => {
          this.changeVendorModal.show();
        }
      }
    ]);
  }

  private removeComponents(): void {
    this.replaceableComponents.add({
      component: SmartInvoicingBreadcrumbComponent,
      key: eThemeLeptonXComponents.Breadcrumb,
    });

    this.replaceableComponents.add({
      component: undefined,
      key: eThemeLeptonXComponents.MobileNavbarSettings,
    });

    this.replaceableComponents.add({
      component: undefined,
      key: eThemeLeptonXComponents.Footer,
    })
  }
}
